import Suspense from "components/shared/Suspense";
import { lazy, useState } from "react";
import InactiveListDropdownButton from "./InactiveListControlsButton";
import { ListSerializersListByline, UserSerializersUserByline } from "types/serializers";

const ActiveListDropdownButton = lazy(
  () => import("./ActiveListDropdownButton")
);

export default function ListDropdown({ list, user }: { list: ListSerializersListByline, user: UserSerializersUserByline }) {
  const [clicked, setClicked] = useState(false);

  return (
    <>
      {clicked ? (
        <Suspense fallback={<InactiveListDropdownButton loading />}>
          <ActiveListDropdownButton list={list} user={user} />
        </Suspense>
      ) : (
        <InactiveListDropdownButton onClick={setClicked} />
      )}
    </>
  );
}
